import { render, staticRenderFns } from "./RepresentativeSettings.vue?vue&type=template&id=64a63a52&scoped=true"
import script from "./RepresentativeSettings.vue?vue&type=script&lang=js"
export * from "./RepresentativeSettings.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeSettings.vue?vue&type=style&index=0&id=64a63a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a63a52",
  null
  
)

export default component.exports